import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  ChatIcon, FolderIcon, WorkflowIcon, MicIcon, DocEditIcon,
  LayersIcon, BriefcaseIcon, TargetIcon, CompassIcon, SlidersIcon, ArrowRightIcon
} from './ProductsIcons';
import './Products.css';

const Products = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleRow = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  const products = [
    {
      icon: ChatIcon,
      category: '智能对话',
      title: '智能助手',
      tagline: '问答办公，一句话说清目标就够了',
      description: '极速问答与智能助手合二为一：简单问题打字机式秒答，随时可停；复杂任务只需说清最终目标，AI自动拆解步骤、调用能力、遇错重试，成果自动整理成可下载文件。',
      chips: ['极速问答', '多步骤任务拆解', '一键生成Word/PDF/PPT/Excel', '跨会话记忆']
    },
    {
      icon: FolderIcon,
      category: '专属知识库',
      title: 'AI文件夹',
      tagline: '让AI只读你的文件，答案句句有出处',
      description: '上传不限数量的文档、图片、音视频、压缩包，AI自动学习索引；提问即可获得带原文引用、可点击定位的精准回答，还能把散落信息一键汇总成结构化表格。',
      chips: ['多格式智能解析', '原文可点击引用', '智能表格提取', '权限共享管理']
    },
    {
      icon: WorkflowIcon,
      category: '自动化流程',
      title: 'AI工作流',
      tagline: '搭一次，用长久——重复工作交给它',
      description: '用大白话描述处理逻辑，AI自动拆解成可编辑、可调试的步骤；发布后每来一批新文件，上传即可一键批量运行，历史记录完整留存，还能看图识别、核验印章。',
      chips: ['自然语言搭建', '逐步预览调试', '批量一键运行', '看图识别核验']
    },
    {
      icon: MicIcon,
      category: 'AI会议室',
      title: '智能会议助理',
      tagline: '开会边聊边记，散会即得纪要',
      description: '覆盖会前、会中、会后全流程：实时转录同传字幕、自动区分发言人，同步生成议题图谱与风险预警；会后一键导出纪要与待办，跨会议任务集中追踪。',
      chips: ['实时转录+翻译', '风险与待办自动提取', '声纹发言人识别', '投屏字幕模式']
    },
    {
      icon: DocEditIcon,
      category: '公文写作',
      title: '公文智能生成',
      tagline: '写公文这件事，终于不用那么熬人了',
      description: '覆盖通知、请示、报告、纪要等数十种公文类型，按格式标准一键生成；可仿照单位范文延续行文习惯，还能从格式、用语、逻辑、内容、标点五个维度自动审查把关。',
      chips: ['数十种公文类型', '范文仿写', '五维度审查', '文档库归档检索']
    },
    {
      icon: LayersIcon,
      category: '文档处理',
      title: '文件处理全家桶',
      tagline: '文件处理的那些小麻烦，一个工具全接住',
      description: '翻译、校对、润色、摘要、对比、转写全部装进一个工具。外文文档保留原始排版整篇互译，扫描件与录音也能精准转成可编辑、可检索的文字。',
      chips: ['50+语言互译', '中文智能校对', '差异高亮对比', 'OCR与录音转写']
    },
    {
      icon: BriefcaseIcon,
      category: '投行专业助手',
      title: 'IPO尽调助手',
      tagline: '问询函一贴，思路和草稿都有了',
      description: '面向投行保荐代表人与IPO项目组，覆盖科创板、创业板、主板真实问询案例：解读问询要点、起草回复草稿、逐项排查漏洞、预判高风险追问话题。',
      chips: ['问询函解读', '回复草稿起草', '风险预判', '同行案例检索']
    },
    {
      icon: TargetIcon,
      category: '科创成果转化',
      title: '成果智能体',
      tagline: '让技术找到需求，让需求找到技术',
      description: '面向科技成果转化机构与产学研对接场景：关键词检索成果、按技术需求匹配推荐企业与专家，还能一键生成专业分析报告与多版式成果评价。',
      chips: ['成果检索匹配', '专家/企业推荐', '智能分析报告', '多版式成果评价']
    },
    {
      icon: CompassIcon,
      category: '深度研究',
      title: 'AI研究助手',
      tagline: '一句话发起，几分钟出一份可溯源的报告',
      description: '输入一个研究主题，AI自动判断是否启用深度研究模式，聚合20个以上信息来源，产出超过2000字、带引用来源的详尽报告，也可基于本地文档展开研究。',
      chips: ['20+来源聚合', '带引用可溯源', '本地文档联动', '导出PDF/Word']
    }
  ];

  return (
    <div className="products-page">
      {/* Hero Banner */}
      <section className="products-hero page-hero">
        <div className="page-hero-pattern"></div>
        <div className="container">
          <span className="hero-eyebrow">9大核心能力 · 开箱即用</span>
          <h1 className="page-title">AI+ 产品功能</h1>
          <p className="page-subtitle">覆盖办公全场景的智能能力矩阵，让机构全面智能化</p>
        </div>
      </section>

      {/* Products Accordion List */}
      <section className="products-section">
        <div className="container">
          <div className="products-list">
            {products.map((product, index) => {
              const Icon = product.icon;
              const isOpen = openIndex === index;
              return (
                <div key={product.title} className={`product-row${isOpen ? ' open' : ''}`}>
                  <button
                    type="button"
                    className="product-row-head"
                    onClick={() => toggleRow(index)}
                    aria-expanded={isOpen}
                  >
                    <span className="product-row-index">0{index + 1}</span>
                    <span className="product-row-icon"><Icon /></span>
                    <span className="product-row-titles">
                      <span className="product-row-title">{product.title}</span>
                      <span className="product-row-tagline">{product.tagline}</span>
                    </span>
                    <span className="product-row-category">{product.category}</span>
                    <span className="product-row-toggle"></span>
                  </button>
                  <div className="product-row-body">
                    <div className="product-row-body-inner">
                      <p className="product-row-desc">{product.description}</p>
                      <div className="product-chips">
                        {product.chips.map((chip) => (
                          <span key={chip} className="product-chip">{chip}</span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}

            {/* More / Enterprise Customization row */}
            <div className={`product-row${openIndex === products.length ? ' open' : ''}`}>
              <button
                type="button"
                className="product-row-head"
                onClick={() => toggleRow(products.length)}
                aria-expanded={openIndex === products.length}
              >
                <span className="product-row-index">10</span>
                <span className="product-row-icon"><SlidersIcon /></span>
                <span className="product-row-titles">
                  <span className="product-row-title">更多：企业级定制</span>
                  <span className="product-row-tagline">按您的实际需求量身搭建</span>
                </span>
                <span className="product-row-category">企业定制</span>
                <span className="product-row-toggle"></span>
              </button>
              <div className="product-row-body">
                <div className="product-row-body-inner">
                  <p className="product-row-desc">
                    针对您单位的专业性场景需求，提供定制化解决方案：品牌与界面定制、行业专属应用扩展、私有化部署——按实际业务场景量身搭建。
                  </p>
                  <Link to="/contact" className="product-more-link">
                    联系我们定制方案 <ArrowRightIcon className="product-more-arrow" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="products-cta">
        <div className="container">
          <h2>找到适合您的AI能力</h2>
          <p>联系我们，获取专属解决方案</p>
          <Link to="/contact" className="btn btn-primary btn-lg">立即咨询</Link>
        </div>
      </section>
    </div>
  );
};

export default Products;
